import { Helmet } from 'react-helmet';
import gmail from '../../assets/gmail.png';
import outlook from '../../assets/outlook.png';
import yahoo from '../../assets/yahoo.png';
import foto_perfil from '../../assets/foto-perfil.png';

export function ApprovedPurchase() {
  return (
    <>
      <Helmet>
        <meta name="robots" content="noindex" />
      </Helmet>
      <div className="container text-center">
        <lord-icon
          src="https://cdn.lordicon.com/tqywkdcz.json"
          trigger="loop"
          delay="200"
          style={{ width: '250px', height: '250px' }}
        ></lord-icon>
        <h1>Parabéns!</h1>
        <br />
        <br />
        <p className="congratulation">
          Você acaba de dar o passo mais importante na carreira como programador
          (a).
        </p>
        <p className="congratulation">
          Acabei de te enviar um e-mail com todas as instruções necessárias para
          acessar o E-book Dev Start!
        </p>
        <p className="congratulation">
          Então, abra seu e-mail e verifique a caixa de entrada, a aba de
          promoções ou, caso não o encontrar, ele estará te esperando na aba
          spam.
        </p>
        <br />
        <br />
        <div className="d-flex justify-content-around mb-5">
          <div
            className="email"
            onClick={() =>
              (window.location.href = 'https://mail.google.com/mail/u/0/')
            }
          >
            <img src={gmail} alt="" />
            <p>Acessar Gmail</p>
          </div>
          <div
            className="email"
            onClick={() =>
              (window.location.href = 'https://outlook.live.com/mail/0/')
            }
          >
            <img src={outlook} alt="" />
            <p>Acessar Outlook</p>
          </div>
          <div
            className="email"
            onClick={() => (window.location.href = 'https://mail.yahoo.com')}
          >
            <img src={yahoo} alt="" />
            <p>Acessar Yahoo</p>
          </div>
        </div>
        <div className="m-auto d-flex profile-photo">
          <img src={foto_perfil} alt="" width={'60px'} />
          <div>
            <p>Alexia Kattah</p>
            <p>@alexiakattah</p>
          </div>
        </div>
      </div>
    </>
  );
}
